import React, { /*forwardRef,*/ Fragment, useEffect, useRef, useState } from 'react';
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  useFilters,
  usePagination,
} from 'react-table';

import ReportBuilder from './ReportBuilder';
import { Select } from 'antd';

// import { Table, Row, Col, Button, Input } from 'reactstrap';
import { Table, Row, Col, Button } from 'reactstrap';
import { Filter, DefaultColumnFilter, GlobalFilterInput } from './filters';

import Cookies from 'js-cookie';
var CryptoJS = require("crypto-js");

// import { Select, Space } from 'antd';

const TableContainer = ({columns, data, renderRowSubComponent, apiError, apiFetch, pageServing, defaultSortedColumn, func }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    page,
    prepareRow,
    allColumns,
    // getToggleHideAllColumnsProps,
    visibleColumns,
    canPreviousPage,
    canNextPage,
    pageOptions,
    // pageCount,
    // gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    // eslint-disable-next-line
    state: { pageIndex, pageSize },
    preGlobalFilteredRows, setGlobalFilter, state
  } = useTable(
    {
      columns,
      data,
      disableSortRemove:true,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: 
        { 
          pageIndex: 0, 
          pageSize: 100,
          sortBy: [
            {
                id: defaultSortedColumn,
                desc: false
            }
          ]
          
        },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? <img src='assets/media/images/down_arrow.svg' className='sorting_icon' alt='down' /> : <img src='assets/media/images/up_arrow.svg' className='sorting_icon' alt='up' />) : '';
  };

  const onChangeInSelect = (value) => {
    setPageSize(Number(value));
  };

  function tableToCSV() {
    var csv_data = [];
    var headersString = '';
    allColumns.forEach(columns => {
      var HeaderValue = '';
      if(columns.id){
        if (columns.id === 'dt' || columns.id === 'date') {
          HeaderValue = 'Date';
        }else if(columns.id === 'ad_id') {
          HeaderValue = 'Ad ID';
        }else if(columns.id === 'ad_name') {
          HeaderValue = 'Ad Name';
        }else if(columns.id === 'adCode') {
          HeaderValue = 'Ad Unit Code';
        }else if(columns.id === 'cNetCode') {
          HeaderValue = 'Child Network Code';
        }else if(columns.id === 'adx_aveImp') {
          HeaderValue = 'Ad Impressions';
        }else if(columns.id === 'adx_clicks') {
          HeaderValue = 'Clicks';
        }else if(columns.id === 'adx_ctr') {
          HeaderValue = 'CTR';
        }else if(columns.id === 'adx_rev') {
          HeaderValue = 'Revenue';
        }else if(columns.id === 'adx_ecpm') {
          HeaderValue = 'Avg eCPM';
        }else if(columns.id === 'adx_req') {
          HeaderValue = 'Total Requests';
        }else if(columns.id === 'adx_matchRate') {
          HeaderValue = 'Match %';
        }else if(columns.id === 'adx_reqECPM') {
          HeaderValue = 'Total Requests eCPM';
        }else if(columns.id === 'adx_matchECPM') {
          HeaderValue = 'Match Request eCPM';
        }else if(columns.id === 'adx_avvImp') {
          HeaderValue = 'Viewable Impressions';
        }else if(columns.id === 'adx_avvImpRate') {
          HeaderValue = 'Viewable Impressions %';
        }else if(columns.id === 'adx_res') {
          HeaderValue = 'Responses Served';
        }
        // Adkernel
        else if(columns.id === 'zone') {
          HeaderValue = 'Zone';
        }else if(columns.id === 'zone_id') {
          HeaderValue = 'Zone Id';
        }else if(columns.id === 'site_domain') {
          HeaderValue = 'Site';
        }else if(columns.id === 'app_bundle') {
          HeaderValue = 'Application';
        }else if(columns.id === 'banner_size') {
          HeaderValue = 'Banner Size';
        }else if(columns.id === 'country') {
          HeaderValue = 'Country';
        }else if(columns.id === 'video_size_ex') {
          HeaderValue = 'Video Size';
        }else if(columns.id === 'rtb_pub_requests') {
          HeaderValue = 'Requests';
        }else if(columns.id === 'rtb_pub_coverage') {
          HeaderValue = 'Responses';
        }else if(columns.id === 'rtb_pub_coverage_rate') {
          HeaderValue = 'Coverage %';
        }else if(columns.id === 'rtb_pub_impressions') {
          HeaderValue = 'Impressions';
        }else if(columns.id === 'rtb_pub_win_rate') {
          HeaderValue = 'Impression Win %';
        }else if(columns.id === 'rtb_pub_net_clicks') {
          HeaderValue = 'Clicks';
        }else if(columns.id === 'rtb_pub_ctr') {
          HeaderValue = 'Gross CTR';
        }else if(columns.id === 'rtb_pub_revenue') {
          HeaderValue = 'Revenue';
        }else if(columns.id === 'rtb_pub_ecpm') {
          HeaderValue = 'eCPM';
        }
      }
      headersString = headersString+HeaderValue+',';
    });
    headersString = headersString.substring(0, headersString.length-1);
    csv_data.push(headersString);
    
    data.forEach(dd => {
      var tBodyString = '';
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(dd)) {
        tBodyString = tBodyString+value+',';
      }
      csv_data.push(tBodyString);
    });
    csv_data = csv_data.join('\n');
    downloadCSVFile(csv_data);

    // var csv_data = [];
    // var rows = document.getElementsByTagName('tr');
    // for (var i = 0; i < rows.length; i++) {
    //   var cols = rows[i].querySelectorAll('td,th');
    //   var csvrow = [];
    //   for (var j = 0; j < cols.length; j++) {
    //     csvrow.push(cols[j].innerText);
    //   }
    //   csv_data.push(csvrow.join(","));
    // }
    // csv_data = csv_data.join('\n');
    // downloadCSVFile(csv_data);
  }

  function downloadCSVFile(csv_data) {
    let opertaedPlatform = '';
    if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).google_id.length > 0){
      opertaedPlatform = 'Google';
    }else if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).aniview_id.length > 0){
      opertaedPlatform = 'Aniview';
    }else if(JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).adkernel_id.length > 0){
      opertaedPlatform = 'Adkernel';
    }
    var currentdate = new Date();
    // let currentDateTime = currentdate.getFullYear()+"-"+(currentdate.getMonth()+1)+"-"+currentdate.getDate()+" "+currentdate.getHours() + "HH " + currentdate.getMinutes() + "MM " + currentdate.getSeconds()+"ss";
    let currentDateTime = currentdate.getFullYear()+"-"+(currentdate.getMonth()+1)+"-"+currentdate.getDate();
    var CSVFile = new Blob([csv_data], {
      type: "text/csv"
    });
    var temp_link = document.createElement('a');
    temp_link.download = opertaedPlatform+"-Report-"+currentDateTime+".csv";
    var url = window.URL.createObjectURL(CSVFile);
    temp_link.href = url;
    temp_link.style.display = "none";
    document.body.appendChild(temp_link);
    temp_link.click();
    document.body.removeChild(temp_link);
  }

  const [colvis, setColvis] = useState(false);

  const refColvis = useRef(null);


  useEffect(() => {
    function handleClickOutside(event) {
      if (refColvis.current && !refColvis.current.contains(event.target)) {
        setColvis(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
  }, [refColvis]);

  const handleColvis = () => {
    setColvis(!colvis)
  }
  
  // const tableChange = (value) => {
  //   console.log(`selected ${value}`);
  // };

  const handleColvisCheckbox = (e) => {
    if(document.getElementById('label-'+e).classList.contains("active")) {
      document.getElementById('label-'+e).classList.remove('active');
    }else {
      document.getElementById('label-'+e).classList.add('active');
    }
    let checkedCheckboxes = 0;
    var colvisCheckboxes = document.querySelectorAll('.colvisCheckboxes');
    for (var ic = 0; ic < colvisCheckboxes.length; ic++) {
      if(colvisCheckboxes[ic].checked) {
        checkedCheckboxes = checkedCheckboxes+1;
      }
    }
    if(checkedCheckboxes === 1) {
      for (var icc = 0; icc < colvisCheckboxes.length; icc++) {
        if(colvisCheckboxes[icc].checked) {
          colvisCheckboxes[icc].disabled=true;
        }
      }
    }else {
      for (var icd = 0; icd < colvisCheckboxes.length; icd++) {
          colvisCheckboxes[icd].disabled=false;
      }
    }
  }

  const pull_data1 = (fm) => {
    func(fm);
  }

  return (
    <Fragment>

      <div className='row'>
        {
          (pageServing === 'dashboard')
          ?
          <>
          <div className='d-flex justify-content-between'>
            <div>
              <h2 className="title_heading">Reports</h2>
            </div>
            <div>
              <div className='d-flex gap-8px'>
                <div className='search_content mb-0'>

                  <GlobalFilterInput
                    className="form_control"
                    preGlobalFilteredRows={preGlobalFilteredRows}
                    setGlobalFilter={setGlobalFilter} globalFilter={state.globalFilter}
                  />
                </div>
              </div>
            </div>
          </div>
          </>
          :
          ''
        }


        <div className='col-md-6'>
          <div className='d-flex gap-8px'>
            <div className='search_content'>
            {
              (pageServing === 'reports' || pageServing === 'admin')
              ?
              <>
                <GlobalFilterInput
                  className="form_control"
                  preGlobalFilteredRows={preGlobalFilteredRows}
                  setGlobalFilter={setGlobalFilter} globalFilter={state.globalFilter}
                />
              </>
              :
              ''
            }
            </div>
            {
              (pageServing === 'reports')
                ?
                <>
                  {/* <div>
                    <Space wrap>
                      <Select
                        defaultValue="Ad Unit"
                        style={{ width: 120 }}
                        onChange={tableChange}
                        // loading
                        className='form_select_table btn_outline'
                        options={[
                          { value: 'one', label: 'Ad Unit' },
                          { value: 'two', label: 'Ad Unit' },
                        ]}
                      />
                    </Space>
                  </div> */}
                  <ReportBuilder func={pull_data1} />
                </>
                :
                ''
            }
          </div>
        </div>

        <div className='col-md-6'>
          <div className='d-flex justify-content-end gap-8px'>

            {(pageServing === 'reports') ? (
              <>
                <div className='colvis_content' ref={refColvis}>
                  <div className='position-relative' onClick={handleColvis}>
                    <button type="button" id="colvis" className={ (colvis) ? 'colvis btn_outline active' : 'colvis btn_outline' }>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.40458 2.66667C5.40458 2.66667 3.25481 2.66899 3.25145 2.66899C2.47857 2.67884 2 3.73102 2 5.33595V10.6641C2 12.2771 2.48221 13.3333 3.26181 13.3333C3.26181 13.3333 5.4113 13.3316 5.41494 13.3316C6.18782 13.3218 6.66667 12.269 6.66667 10.6641V5.33595C6.66667 3.72291 6.18418 2.66667 5.40458 2.66667Z" stroke="#1D8F83" strokeLinecap="round" strokeLinejoin="round" />
                        <path fillRule="evenodd" clipRule="evenodd" d="M12.7378 2.66667C12.7378 2.66667 10.5881 2.66899 10.5847 2.66899C9.81182 2.67884 9.33325 3.73102 9.33325 5.33595V10.6641C9.33325 12.2771 9.81546 13.3333 10.5951 13.3333C10.5951 13.3333 12.7446 13.3316 12.7482 13.3316C13.5211 13.3218 13.9999 12.269 13.9999 10.6641V5.33595C13.9999 3.72291 13.5174 2.66667 12.7378 2.66667Z" stroke="#1D8F83" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      Column
                    </button>
                    <div className="dropdown-menu" style={{ display: (colvis) ? 'block' : 'none' }}>
                      {/* <Checkbox {...getToggleHideAllColumnsProps()} /> Toggle All */}
                      {
                        allColumns.map(column => (
                          (['dt','ad_id','ad_name','adCode','cNetCode'].includes(column.id))
                          ?
                          ''
                          :
                          <div key={column.id} className="form-check">
                            <label id={"label-"+column.id} className="label_main active">
                              <input type="checkbox" id={column.id} className="form-check-input colvisCheckboxes" {...column.getToggleHiddenProps()} onClick={(e) => handleColvisCheckbox(e.target.id)} />
                              {/* {column.Header} */}
                              {(column.id === 'dt' || column.id === 'date') ? <span>Date </span> : ''}
                              {(column.id === 'ad_id') ? <span>Ad ID </span> : ''}
                              {(column.id === 'ad_name') ? <span>Ad Name </span> : ''}
                              {(column.id === 'adCode') ? <span>Ad Unit Code </span> : ''}
                              {(column.id === 'cNetCode') ? <span>Child Network Code </span> : ''}
                              {(column.id === 'adx_aveImp') ? <span>Ad Impressions </span> : ''}
                              {(column.id === 'adx_clicks') ? <span>Clicks </span> : ''}
                              {(column.id === 'adx_ctr') ? <span>CTR % </span> : ''}
                              {(column.id === 'adx_rev') ? <span>Revenue </span> : ''}
                              {(column.id === 'adx_ecpm') ? <span>Avg eCPM </span> : ''}
                              {(column.id === 'adx_req') ? <span>Total Requests </span> : ''}
                              {(column.id === 'adx_matchRate') ? <span>Match % </span> : ''}
                              {(column.id === 'adx_reqECPM') ? <span>Total Requests eCPM </span> : ''}
                              {(column.id === 'adx_matchECPM') ? <span>Match Request eCPM </span> : ''}
                              {(column.id === 'adx_avvImp') ? <span>Viewable Impressions </span> : ''}
                              {(column.id === 'adx_avvImpRate') ? <span>Viewable Impressions % </span> : ''}
                              {(column.id === 'adx_res') ? <span>Responses Served </span> : ''}
                              {/* Adkernel */}
                              {(column.id === 'zone') ? <span>Zone </span> : ''}
                              {(column.id === 'zone_id') ? <span>Zone Id </span> : ''}
                              {(column.id === 'site_domain') ? <span>Site </span> : ''}
                              {(column.id === 'app_bundle') ? <span>Application </span> : ''}
                              {(column.id === 'banner_size') ? <span>Banner Size </span> : ''}
                              {(column.id === 'country') ? <span>Country </span> : ''}
                              {(column.id === 'video_size_ex') ? <span>Video Size </span> : ''}
                              {(column.id === 'rtb_pub_requests') ? <span>Requests </span> : ''}
                              {(column.id === 'rtb_pub_coverage') ? <span>Responses </span> : ''}
                              {(column.id === 'rtb_pub_coverage_rate') ? <span>Coverage % </span> : ''}
                              {(column.id === 'rtb_pub_impressions') ? <span>Impressions </span> : ''}
                              {(column.id === 'rtb_pub_win_rate') ? <span>Impression Win % </span> : ''}
                              {(column.id === 'rtb_pub_net_clicks') ? <span>Clicks </span> : ''}
                              {(column.id === 'rtb_pub_ctr') ? <span>Gross CTR </span> : ''}
                              {(column.id === 'rtb_pub_revenue') ? <span>Revenue </span> : ''}
                              {(column.id === 'rtb_pub_ecpm') ? <span>eCPM </span> : ''}
                              
                            </label>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </div>
                <div className='export_btn'>
                  <button type="button" className="btn_outline" onClick={tableToCSV}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M9.82451 1.84121H5.38984C4.00318 1.83587 2.86718 2.94054 2.83384 4.32721V11.4852C2.80384 12.8865 3.91584 14.0465 5.31651 14.0765C5.34118 14.0765 5.36584 14.0772 5.38984 14.0765H10.7152C12.1085 14.0272 13.2098 12.8792 13.2018 11.4852V5.35854L9.82451 1.84121Z" stroke="#1D8F83" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M9.6499 1.8334V3.77274C9.6499 4.7194 10.4159 5.48674 11.3626 5.4894H13.1986" stroke="#1D8F83" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M7.76131 10.6332V6.60588" stroke="#1D8F83" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M6.19751 9.06294L7.76084 10.6329L9.32418 9.06294" stroke="#1D8F83" strokeLinecap="round" strokeLinejoin="round" />
                  </svg> Export</button>
                </div>
              </>
            ) : (
              ''
            )}

          </div>
        </div>
      </div>

      <div className='table-responsive'>
        <Table bordered hover id="data-table" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    <div {...column.getSortByToggleProps({ title: undefined })}>
                      {column.render('Header')}
                      {generateSortingIndicator(column)}
                    </div>
                    <Filter column={column} />
                  </th>
                ))}
              </tr>
            ))}
          </thead>


          {

            (apiFetch) ? (
              (apiError) ? (
                <tbody><tr><td colSpan={13} className="p-0"><span className='errortable'><img src="/assets/media/images/Error.svg" alt="Error" /></span></td></tr></tbody>
              ) : (
                (page.length > 0) ? (
                  <>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <Fragment key={row.getRowProps().key}>
                            <tr>
                              {row.cells.map((cell) => {
                                return (
                                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                );
                              })}
                            </tr>
                            {row.isExpanded && (
                              <tr>
                                <td colSpan={visibleColumns.length}>
                                  {renderRowSubComponent(row)}
                                </td>
                              </tr>
                            )}
                          </Fragment>
                        );
                      })}
                    </tbody>
                    {
                      (footerGroups[0].headers[0].Footer !== '')
                      ?
                      <>
                        {
                          (pageServing !== 'dashboard')
                          ?
                          <tfoot>
                            {
                              footerGroups.map(footerGroup => (
                                <tr {...footerGroup.getFooterGroupProps()}>
                                  {
                                    footerGroup.headers.map(column => (
                                      <td key={column.id} {...column.getFooterProps}>
                                        {
                                          column.render('Footer')
                                        }
                                      </td>
                                    ))
                                  }
                                </tr>
                              ))
                            }
                          </tfoot>
                          :
                          ''
                        }
                      </>
                      :
                      <></>
                    }
                    
                  </>
  
                ) : (
                  <tbody><tr><td colSpan={13} className="p-0"><span className='nodataTable'><img src="/assets/media/images/no-data.svg" alt="No Data" /></span></td></tr></tbody>
                )
              )
            ) : (
              <tbody>
                <tr>
                  <td colSpan={13} className="p-0">
                    <span className="nodataTable">
                      <div className='text-center'>
                        <div className="loader-animation m-auto">
                          <img src="/assets/media/images/table-loader.svg" alt="Table Loader" />
                        </div>
                        <div>
                          <h6>Processing</h6>
                          <p>Your list is loading</p>
                        </div>
                      </div>
                    </span>
                  </td>
                </tr>
              </tbody>
            )


          }

          {/* {(page.length > 0) ? (
              <tbody {...getTableBodyProps()}>
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <Fragment key={row.getRowProps().key}>
                        <tr>
                          {row.cells.map((cell) => {
                            return (
                              <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                            );
                          })}
                        </tr>
                        {row.isExpanded && (
                          <tr>
                            <td colSpan={visibleColumns.length}>
                              {renderRowSubComponent(row)}
                            </td>
                          </tr>
                        )}
                      </Fragment>
                    );
                  })}
              </tbody>
          ) : (
            <span><img src="/assets/media/images/no-data.svg" alt="No Data" /></span>
          )}
          {(page.length > 0) ? (
              <tfoot>
              {
                footerGroups.map(footerGroup => (
                  <tr {...footerGroup.getFooterGroupProps()}>
                    {
                      footerGroup.headers.map(column => (
                        <td {...column.getFooterProps}>
                          {
                            column.render('Footer')
                          }
                        </td>
                      ))
                    }
                  </tr>
                ))
              }
            </tfoot>
          ) : (
            ''
          )} */}

        </Table>
      </div>
        
      {
        (page.length > 0)
        ?
        <Row>
          <Col md={6}>
            <div className='pagination_content d-flex'>
              {/* <Input
                type='select'
                value={pageSize}
                onChange={onChangeInSelect}
              >
                {'>'}
                {[10, 20, 30, 40, 50, 100, 200, 500, 1000].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </Input> */}

              <Select
                defaultValue="100"
                onChange={onChangeInSelect}
                className="btn_select page_select"
                options={[
                  { value: 100, label: '100' },
                  { value: 200, label: '200' },
                  { value: 500, label: '500' },
                ]}
              />
              <label>Items per page</label>
              
              {/* <Space wrap>
                  <Select
                      defaultValue="10"
                      style={{ width: 120 }}
                      // onChange={handleChange}
                      // loading
                      className='form_select_main form-select form_select_xs'
                      // options={[
                      //     { value: 'USD', label: '$ USD' },
                      // ]}
                      options={
                        [
                          { value: '10', label: '10' },
                          { value: '20', label: '20' },
                          { value: '30', label: '30' },
                          { value: '40', label: '40' },
                          { value: '50', label: '50' },
                        ]
                      }
                  />
              </Space> */}

            </div>
          </Col>


          {/* <Col md={2}>
            <Input
              type='number'
              min={1}
              style={{ width: 70 }}
              max={pageOptions.length}
              defaultValue={pageIndex + 1}
              onChange={onChangeInInput}
            />
          </Col> */}


          <Col md={6}>
            <div className='d-flex justify-content-end'>
              <div className="arrows_content">
                {' '}
                <label>
                  {pageIndex + 1} of {pageOptions.length}
                </label>
                <label className='ms-1'>Pages</label>

                {/* <Button
              color='primary'
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {'<<'}
            </Button> */}
                <Button
                    className='px-2 btn-icon-page'
                    onClick={previousPage}
                    disabled={!canPreviousPage}
                  >
                    {

                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.333 12.6667L5.66634 8.00001L10.333 3.33334" stroke="#757575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>

                    }
                  </Button>
                  <Button
                    className='px-2 btn-icon-page'
                    onClick={nextPage} disabled={!canNextPage}>
                    {

                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.6665 3.33332L10.3332 7.99999L5.6665 12.6667" stroke="#757575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>

                    }
                  </Button>
                {/* <Button
              color='primary'
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {'>>'}
            </Button> */}
              </div>
            </div>
          </Col>
          
        </Row>
        :
        ''
      }
      
    </Fragment>
  );
};

export default TableContainer;